import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const bootstrapApp = () => {
  createRoot(document.getElementById("root")!).render(<App />);
};

const clearLegacyServiceWorkers = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ('caches' in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } catch (error) {
    console.warn('Failed to clear legacy service workers:', error);
  }
};

clearLegacyServiceWorkers().finally(bootstrapApp);
